module.exports = __webpack_public_path__ + "img/hzm-bottom.a8f8d87d.png";